import { useMemo } from 'react';

import { DictTypes } from '@/constants';
import { setDictionaryOptions } from '@/services';
import { useAppSelector } from '@/store';

const useSelectsOptions = () => {
  const { dicts } = useAppSelector((state) => state.dict);

  const dealers = useMemo(
    () =>
      setDictionaryOptions(DictTypes.Dealers, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );

  const autoTypes = useMemo(
    () =>
      setDictionaryOptions(DictTypes.AutoTypes, dicts)
        ?.map((item) => ({
          value: String(item.value),
          label: String(item.label)
        }))
        // Убираем Б\У авто и Коммерческие авто
        .filter((item) => item.value !== '3' && item.value !== '2') || [],
    [dicts]
  );

  const loanTerms = useMemo(
    () =>
      setDictionaryOptions(DictTypes.LoanTerms, dicts)
        ?.map((item) => ({
          value: String(item.value),
          label: String(item.label)
        }))
        .sort((a, b) => +b.value - +a.value) || [],
    [dicts]
  );

  const engineTypes = useMemo(
    () =>
      setDictionaryOptions(DictTypes.EngineTypes, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );

  const repaymentTypes = useMemo(
    () =>
      setDictionaryOptions(DictTypes.RepaymentTypes, dicts)?.map((item) => ({
        value: String(item.value),
        label: String(item.label)
      })) || [],
    [dicts]
  );

  return { dealers, autoTypes, loanTerms, engineTypes, repaymentTypes };
};

export default useSelectsOptions;
